export default __webpack_public_path__ + "media/images/up_arrow-659ca9e2037ff58bc12f181cc25a1850.png";